<template>
  <div class="loading-roulette">
    <svg
      viewBox="0 0 100 100"
      width="120"
      height="120"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g class="roulette" style="transform-origin: 50px 50px">
        <!-- چرخ اصلی -->
        <circle
          cx="50"
          cy="50"
          r="42"
          fill="#1a1a1a"
          stroke="#f1c40f"
          stroke-width="4"
        />
        <circle cx="50" cy="50" r="38" fill="#0f0f0f" />

        <!-- بخش‌های رنگی (قرمز/مشکی) -->
        <g v-for="i in 36" :key="i">
          <path
            :d="sectorPath(i)"
            :fill="i % 2 === 0 ? '#c0392b' : '#1a1a1a'"
            stroke="#f1c40f"
            stroke-width="0.8"
          />
          <text
            :x="50 + 32 * Math.cos(((i * 10 - 5) * Math.PI) / 180)"
            :y="50 + 32 * Math.sin(((i * 10 - 5) * Math.PI) / 180)"
            font-family="Arial, sans-serif"
            font-size="6"
            fill="#fff"
            text-anchor="middle"
            dominant-baseline="middle"
            font-weight="bold"
          >
            {{ i }}
          </text>
        </g>

        <!-- مرکز طلایی -->
        <circle
          cx="50"
          cy="50"
          r="12"
          fill="#f1c40f"
          stroke="#d4ac0d"
          stroke-width="3"
        />
        <circle cx="50" cy="50" r="8" fill="#000" />

        <!-- فلش نشانگر بالا -->
        <path
          d="M50 8 L44 18 L56 18 Z"
          fill="#f1c40f"
          stroke="#d4ac0d"
          stroke-width="1.5"
        />
      </g>
    </svg>

    <!-- متن لاکچری -->
    <div class="luxury-text">در حال چرخش شانس...</div>
  </div>
</template>

<script>
export default {
  name: "LoadingBet",
  methods: {
    sectorPath(i) {
      const angle = i * 10;
      const x1 = 50 + 38 * Math.cos(((angle - 5) * Math.PI) / 180);
      const y1 = 50 + 38 * Math.sin(((angle - 5) * Math.PI) / 180);
      const x2 = 50 + 38 * Math.cos(((angle + 5) * Math.PI) / 180);
      const y2 = 50 + 38 * Math.sin(((angle + 5) * Math.PI) / 180);
      return `M50,50 L${x1},${y1} A38,38 0 0 1 ${x2},${y2} Z`;
    },
  },
};
</script>

<style scoped>
.loading-roulette {
  position: fixed;
  top: 50%;
  left: 50%;
  width: 140px;
  height: 160px;
  background: linear-gradient(
    135deg,
    rgba(15, 15, 15, 0.95),
    rgba(30, 30, 30, 0.9)
  );
  border-radius: 50%;
  overflow: hidden;
  transform: translate(-50%, -50%);
  z-index: 9999;
  padding: 10px;
  border: 3px solid #f1c40f;
  box-shadow: 0 0 30px rgba(241, 196, 15, 0.7), 0 0 60px rgba(241, 196, 15, 0.5),
    inset 0 0 30px rgba(255, 255, 255, 0.15);
  animation: pulse-glow 2s infinite ease-in-out;
}

.roulette {
  animation: spin-bounce 1.8s infinite ease-in-out;
  filter: drop-shadow(0 0 10px #f1c40f);
}

.luxury-text {
  position: absolute;
  bottom: -12px;
  left: 50%;
  transform: translateX(-50%);
  font-family: "Georgia", "Vazir", serif;
  font-size: 13px;
  font-weight: bold;
  color: #f1c40f;
  text-shadow: 0 0 8px #000, 0 0 15px #f1c40f;
  white-space: nowrap;
  letter-spacing: 1px;
}

/* انیمیشن‌ها */
@keyframes spin-bounce {
  0%,
  100% {
    transform: translateY(0) rotate(0deg) scale(0.85);
  }
  50% {
    transform: translateY(-24px) rotate(180deg) scale(0.95);
  }
}

@keyframes pulse-glow {
  0%,
  100% {
    box-shadow: 0 0 30px rgba(241, 196, 15, 0.7),
      0 0 60px rgba(241, 196, 15, 0.5), inset 0 0 30px rgba(255, 255, 255, 0.15);
  }
  50% {
    box-shadow: 0 0 40px rgba(241, 196, 15, 0.9),
      0 0 80px rgba(241, 196, 15, 0.7), inset 0 0 40px rgba(255, 255, 255, 0.2);
  }
}
</style>
